import { Button } from '@almbrand/button';
import { Paragraph } from '@almbrand/paragraph';
import { ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { CURRENCY_MONTHLY_SHORT, CURRENCY_SHORT } from '../Basket';
import styles from './ProductItem.module.scss';

export interface ProductItemProps {
	price?: number;
	previousPrice?: number;
	onDetails?: () => void;
	onDelete?: () => void;
	onEdit?: () => void;
	themeName: ThemeUnion;
	text: {
		title: string;
		subtitle: string;
		pendingCalculationText: string;
		detailsBtnLabel: string;
		deleteBtnLabel: string;
		editBtnLabel: string;
	};
}

export const ProductItem: React.FC<ProductItemProps> = ({
	price,
	previousPrice,
	onDetails,
	onDelete,
	onEdit,
	themeName,
	text: { title, subtitle, detailsBtnLabel, pendingCalculationText, deleteBtnLabel, editBtnLabel } = {},
}) => {
	const pendingCalculation = price === undefined;

	return (
		<>
			<div className={styles.ProductItem__top}>
				<div className={styles.ProductItem__header}>
					<div className={styles.ProductItem__content}>
						<Paragraph
							text={title}
							paragraphType={{ kind: 'title', type: 'standfirst' }}
							fontColor='primaryDark'
						/>
						<Paragraph
							text={subtitle}
							paragraphType={{ kind: 'title', type: 'standfirst' }}
							fontColor='primaryDark'
							className={styles.ProductItem__subtitle}
						/>
					</div>

					<div className={styles.ProductItem__actions}>
						{onDelete && (
							<Button
								buttonType='circle'
								size='small'
								onClick={onDelete}
								iconProps={{
									themeName,
									icon: 'garbage_can',
									width: 24,
									height: 24,
									fill: 'var(--color-primary-5)',
									'aria-label': deleteBtnLabel,
								}}
							>
								{deleteBtnLabel}
							</Button>
						)}
						{onEdit && (
							<Button
								buttonType='circle'
								size='small'
								onClick={onEdit}
								iconProps={{
									themeName,
									icon: 'pencil' as never,
									width: 24,
									height: 24,
									fill: 'var(--color-primary-5)',
									'aria-label': editBtnLabel,
								}}
							>
								{editBtnLabel}
							</Button>
						)}
					</div>
				</div>

				{pendingCalculation && (
					<Paragraph
						text={pendingCalculationText}
						paragraphType={{ kind: 'title', type: 'standfirst' }}
						className={styles.ProductItem__pendingCalculation}
					/>
				)}
			</div>

			<div className={styles.ProductItem__footer}>
				{onDetails && !pendingCalculation && (
					<Button
						buttonType='link'
						size='large'
						onClick={onDetails}
						iconPosition='right'
						className={styles.ProductItem__detailsButton}
						iconProps={{
							themeName,
							icon: 'Info',
							width: 16,
							height: 16,
							'aria-label': detailsBtnLabel,
						}}
					>
						{detailsBtnLabel}
					</Button>
				)}

				<p className={styles.ProductItem__priceBlock}>
					{pendingCalculation ? (
						<span>--- {CURRENCY_MONTHLY_SHORT}</span>
					) : (
						<>
							{!!previousPrice && (
								<span className={styles.ProductItem__oldPrice}>
									{previousPrice} {CURRENCY_SHORT}
								</span>
							)}
							<span>
								{price} {CURRENCY_MONTHLY_SHORT}
							</span>
						</>
					)}
				</p>
			</div>
		</>
	);
};
